import { render } from "./SplitTwins.vue?vue&type=template&id=739f1c28&scoped=true&lang=pug"
import script from "./SplitTwins.vue?vue&type=script&lang=js"
export * from "./SplitTwins.vue?vue&type=script&lang=js"

import "./SplitTwins.vue?vue&type=style&index=0&id=739f1c28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739f1c28"]])

export default __exports__